import { render, staticRenderFns } from "./ConvoPreviewWrapper.vue?vue&type=template&id=112dbe62&scoped=true&"
import script from "./ConvoPreviewWrapper.vue?vue&type=script&lang=js&"
export * from "./ConvoPreviewWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ConvoPreviewWrapper.vue?vue&type=style&index=0&id=112dbe62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112dbe62",
  null
  
)

export default component.exports